export default __webpack_public_path__ + "static/media/logoutOutlined.d87dc0fa.svg";